import React, {FC, useCallback, useEffect, useState} from 'react'
import {mondayApiService} from '../services/mondayApi'
import MondayConfigModal from './MondayConfigModal'
import MondayManageModal from './MondayManageModal'

interface MondayIntegrationCardProps {}

const MondayIntegrationCard: FC<MondayIntegrationCardProps> = () => {
  const [isConfigured, setIsConfigured] = useState(false)
  const [mappedBoardsCount, setMappedBoardsCount] = useState(0)
  const [loadingStatus, setLoadingStatus] = useState(true)
  const [showConfigModal, setShowConfigModal] = useState(false)
  const [showManageModal, setShowManageModal] = useState(false)

  const loadStatus = useCallback(async () => {
    try {
      setLoadingStatus(true)
      const status = await mondayApiService.getStatus()
      setIsConfigured(status.is_configured)
      setMappedBoardsCount(status.mapped_boards_count || 0)
    } catch {
      setIsConfigured(false)
      setMappedBoardsCount(0)
    } finally {
      setLoadingStatus(false)
    }
  }, [])

  useEffect(() => {
    loadStatus()
  }, [loadStatus])

  return (
    <>
      <div className='card h-100 w-100 d-flex flex-column'>
        <div className='card-header border-0 pt-5'>
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-50px me-5'>
              <div className='symbol-label bg-light-primary'>
                <i className='fas fa-th-large fs-2x' style={{color: '#5d7a1f'}}></i>
              </div>
            </div>
            <div className='d-flex flex-column flex-grow-1'>
              <h3 className='card-title align-items-start flex-column mb-0'>
                <span className='card-label fw-bold fs-4 mb-2'>Monday.com</span>
                <span className='text-muted mt-1 fw-semibold fs-7'>Sincronizar boards e itens</span>
              </h3>
            </div>
            {!loadingStatus && (
              <span
                className={`badge ${isConfigured ? 'badge-light-success' : 'badge-light-warning'}`}
              >
                {isConfigured ? 'Configurado' : 'Não configurado'}
              </span>
            )}
          </div>
        </div>

        <div className='card-body pt-0 d-flex flex-column flex-grow-1'>
          <div className='mb-6 flex-grow-1'>
            <p className='text-muted fs-7 mb-4'>
              Configure o API Token do Monday.com, mapeie boards para projetos do TaskRush e importe
              itens. Alterações no Monday atualizam o TaskRush via webhook; alterações no TaskRush
              são enviadas de volta ao Monday.
            </p>
            {isConfigured && (
              <div className='d-flex flex-column gap-1'>
                <p className='text-muted fs-8 mb-0'>
                  <i className='fas fa-link me-1'></i>
                  {mappedBoardsCount} board(s) mapeado(s)
                </p>
              </div>
            )}
          </div>

          <div className='mt-auto d-flex flex-column gap-2'>
            <button
              type='button'
              className='btn btn-sm btn-primary w-100'
              onClick={() => setShowConfigModal(true)}
            >
              <i className='fas fa-cog me-2'></i>
              {isConfigured ? 'Configurar credenciais' : 'Configurar integração'}
            </button>
            {isConfigured && (
              <button
                type='button'
                className='btn btn-sm btn-light-primary w-100'
                onClick={() => setShowManageModal(true)}
                disabled={loadingStatus}
              >
                <i className='fas fa-project-diagram me-2'></i>
                Gerenciar mapeamentos e importar
              </button>
            )}
          </div>
        </div>
      </div>

      <MondayConfigModal
        show={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        onSuccess={loadStatus}
      />

      <MondayManageModal
        show={showManageModal}
        onClose={() => setShowManageModal(false)}
        onSuccess={loadStatus}
      />
    </>
  )
}

export default MondayIntegrationCard
